import HeatReport from "@/pages/heat-report";
import { Suspense } from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import { LazyLoading } from "../../controls/LazyLoading";

const HeatReportIdRedirect = () => {
	const { heatId } = useParams<{ heatId: string }>();
	return <Navigate to={`/heat-report/${heatId}/eaf`} replace />;
};

export const HeatReportRoutes = [
	// Old route redirects for backward compatibility
	<Route
		key="heat-process-report-redirect"
		path="/heat-process-report"
		element={<Navigate to="/heat-report/latest/eaf" replace />}
	/>,
	<Route
		key="heat-process-report-asset"
		path="/heat-process-report/:asset"
		element={<Navigate to="/heat-report/latest/eaf" replace />}
	/>,

	// New routes with heatId in URL
	<Route
		key="heat-report-base"
		path="/heat-report"
		element={<Navigate to="/heat-report/latest/eaf" replace />}
	/>,
	<Route
		key="heat-report-id"
		path="/heat-report/:heatId"
		element={<HeatReportIdRedirect />}
	/>,
	<Route
		key="heat-report-full"
		path="/heat-report/:heatId/:stage"
		element={
			<Suspense fallback={<LazyLoading />}>
				<HeatReport />
			</Suspense>
		}
	/>,
];
